import { StyleSheet, Platform } from 'react-native'
import { stdCouleurBleu, pageContainerStyle } from '@commonStyle';

const isWeb = Platform.OS === 'web';

const styles = StyleSheet.create({
    container: {
      ...pageContainerStyle,
      backgroundColor: '#ffffff',
      paddingHorizontal: 16,
      paddingVertical: 20,
    },
  taskContour : {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    margin: 12,
    overflow: 'hidden',
    // Ombres modernes
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.12,
    shadowRadius: 12,
    elevation: 6,
    borderWidth: 1,
    borderColor: '#f1f5f9',
    minHeight: 200,
    width: '95%',
  },
  taskContourTitle: {
    backgroundColor: stdCouleurBleu,
    padding: 20,
    alignItems: 'center',
    minHeight: 90,
    justifyContent: 'center',
    position: 'relative',
  },
  // Nouveaux styles modernes
  taskContentContainer: {
    padding: 20,
  },
  taskImageContainer: {
    marginBottom: 16,
    borderRadius: 12,
    overflow: 'hidden',
  },
  taskDescriptionContainer: {
    paddingLeft: isWeb ? 20 : 0,
  },
  taskActionsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: '#f1f5f9',
    marginTop: 16,
  },
  taskTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: 'white',
    textAlign: 'center',
    marginBottom: 8,
    letterSpacing: 0.5,
  },
  taskDate: {
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: 14,
    fontWeight: '500',
  },
  taskImage: {
    resizeMode: 'contain',
    height: 300,
    width: '100%',
    borderRadius: 12,
  },
  taskMore: {
    color: stdCouleurBleu,
    fontWeight: '600',
    fontSize: 16,
    paddingVertical: 8,
    paddingHorizontal: 16,
    backgroundColor: '#f0f9ff',
    borderRadius: 20,
    textAlign: 'center',
    overflow: 'hidden',
  },
  taskItem: {
    fontSize: 15,
    lineHeight: 22,
    color: '#374151',
    marginBottom: 12,
  },
  // Styles pour les badges/tags
  taskBadge: {
    backgroundColor: '#f0f9ff',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    alignSelf: 'flex-start',
    marginBottom: 8,
  },
  taskBadgeText: {
    color: stdCouleurBleu,
    fontSize: 12,
    fontWeight: '600',
  },
  // Styles pour le layout responsive
  taskContentRow: {
    flexDirection: isWeb ? 'row' : 'column',
    gap: 16,
  },
  taskImageFlex: {
    flex: isWeb ? 1 : undefined,
  },
  taskDescriptionFlex: {
    flex: isWeb ? 2 : undefined,
  },
  // Styles pour les actions
  taskFileInfo: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  taskFileText: {
    marginLeft: 8,
    fontSize: 12,
    color: '#6b7280',
  },
  // Styles pour le Dialog
  dialogDateText: {
    fontSize: 16,
    marginBottom: 10,
    color: '#666',
    flexShrink: 1,
    minHeight: 18,
  },
  dialogImage: {
    width: '100%',
    height: 200,
    borderRadius: 10,
    marginBottom: 15,
    resizeMode: 'contain',
  },
  dialogContentText: {
    fontSize: 16,
    lineHeight: 24,
    textAlign: 'justify',
  },
  dialogFileButton: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 20,
    padding: 10,
    backgroundColor: '#f0f9ff',
    borderRadius: 10,
  },
  dialogFileButtonText: {
    marginLeft: 10,
    color: stdCouleurBleu,
    fontWeight: '500',
  },
  dialogFileButtonDisabled: {
    opacity: 0.6,
  },
})

export default styles
